import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import CustomersList from './CustomersList';
import RejectedCustomers from './RejectedCustomers';

function Customers() {
  return (
    <Routes>
      <Route path="/" element={<CustomersList />} />
      <Route path="/rejected" element={<RejectedCustomers />} />
      <Route path="*" element={<Navigate to="/customers" replace />} />
    </Routes>
  );
}

export default Customers; 